<template>
  <div class="riskControlDialog">
    <div class="riskControlDialogContent" :style="`background-image: url(${data.icon});`">
      <h2>最高可提{{data.discountValue}}元</h2>
      <div class="content-detail">
        <div class="content1"><span class="red">{{data.discountValueV2}}元</span>临额券</div>
      </div>
      <nd-button class="withdraw" @click="handleButtonClick" :class="`caseid-${caseid}`">立即提现</nd-button>
    </div>
  </div> 
</template>

<script>
import dayjs from 'dayjs'
export default {
  data () {
    return {
      visible: true
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    couponEndTime () {
      return dayjs(this.data.couponEndTime).format('MM月DD日')
    }
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    handleButtonClick () {
      this.$router.push({
        path: '/middle/limit'
      })
    },
    show () {}
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.riskControlDialog {
  .riskControlDialogContent {
    width: 620px;
    height: 750px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    h2 {
      font-weight: 500;
      font-size: 58px;
      color: #020207;
      text-align: center;
      padding-top:80px;
    }
    .content-detail {
      font-family: PingFangSC, PingFang SC;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-top: 100px;
      color: #333;

      .red {
        color: #FF5434 !important;
      }
      .content1 {
        font-size: 48px;
        font-weight: 500;
      }
     
    }
    
    .withdraw {
        position: absolute;
        top: 540px;
        width: 440px;
        height: 80px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
    }
  }
}
</style>